import React, { useEffect, useState, useMemo, useRef } from "react";
import axios from "axios";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { AgGridReact } from "ag-grid-react";
import Flatpickr from "react-flatpickr";
import { Tooltip } from "react-tooltip";
import "flatpickr/dist/themes/material_blue.css";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import "./ModifyRecords.css";
import confirmDatePlugin from "flatpickr/dist/plugins/confirmDate/confirmDate";
import Select from "react-select";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import IconButton from "@mui/material/IconButton";
import TooltipMui from "@mui/material/Tooltip";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import ArrowBackIcon from "@mui/icons-material/ArrowBack"; 
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";

const ivmsPointToRegionMap = {
  "Abu Madhabi": "Haima/Duqm",
  Amal: "South",
  Ajaiz: "Haima/Duqm",
  Adeela: "Haima/Duqm",
  Auwafiya: "North",
  Burhan: "North",
  Duqm: "Haima/Duqm",
  Fahud: "North",
  Ghaba: "North",
  Hailat: "North",
  Haima: "Haima/Duqm",
  Lekhwair: "North",
  Marmoul: "South",
  Mukhaizna: "South",
  Nimr: "South",
  "Qarn Alam": "North",
  Raba: "North",
  Rahab: "South",
  Rasbintoot: "Haima/Duqm",
  "Saih Rowl": "North",
  Yibal: "North",
  Zuliyah: "Haima/Duqm"
};

const MulIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z" />
  </svg>
);

const ModifyRecords = () => {
  const navigate = useNavigate();
  const gridRef = useRef(null);
  const [filteredRecords, setFilteredRecords] = useState([]);
  const [originalRecords, setOriginalRecords] = useState([]);
  const [dropdownData, setDropdownData] = useState({});
  const [selectedStatus, setSelectedStatus] = useState("IN TRANSIT");
  const [isLoading, setIsLoading] = useState(true);
  const [message, setMessage] = useState("");
  const [pendingChanges, setPendingChanges] = useState([]);
  const [pageSize] = useState(100);
  const [journeyCount, setJourneyCount] = useState(0);
  const [timer, setTimer] = useState(0);
  const [timerActive, setTimerActive] = useState(false);
  const [selectedRowsCount, setSelectedRowsCount] = useState(0);
  const [selectedColumn, setSelectedColumn] = useState("");
  const [newValue, setNewValue] = useState("");
  const [highlightedRows, setHighlightedRows] = useState(() => {
    const saved = localStorage.getItem("highlightedRows");
    return saved ? new Set(JSON.parse(saved)) : new Set();
  });
  const [deleteMode, setDeleteMode] = useState(false);
  const [driverRestStatus, setDriverRestStatus] = useState({});
  const [showRestModal, setShowRestModal] = useState(false);
  const [selectedDriver, setSelectedDriver] = useState(null);
  const [restForm, setRestForm] = useState({
    startDate: new Date().toISOString().slice(0, 16),
    durationHours: 24,
  });
  // New state for active drivers list from API
  const [activeDrivers, setActiveDrivers] = useState([]);
  // New state for DFMS report modal
  const [showDfmsReport, setShowDfmsReport] = useState(false);
  const [dfmsReportData, setDfmsReportData] = useState([]);
  // For DFMS details dialog
  const [dfmsDetailsOpen, setDfmsDetailsOpen] = useState(false);
  const [dfmsDetailsVehicle, setDfmsDetailsVehicle] = useState("");
  const [dfmsDetailsRows, setDfmsDetailsRows] = useState([]);

  // Existing arrays
  const sjmOptions = ["Salim Al Mammari"];

  const getSjmCellStyle = (params) => {
    const sjmColorMap = {
      "mohammed r": { backgroundColor: "#A3B9FF" },
      essam: { backgroundColor: "#FFD1D1" },
      "mohammed m": { backgroundColor: "#D0E0A7" },
      albaloushi: { backgroundColor: "#D1A7E5" },
      saif: { backgroundColor: "#B2E6B7" },
      "mohammed a": { backgroundColor: "#A8D8D8" },
      almonther: { backgroundColor: "#F1C27D" },
      issa: { backgroundColor: "#B3E0E0" },
      "khalil h": { backgroundColor: "#F2A2D2" },
      "khalil r": { backgroundColor: "#F7C2C2" }
    };

    const name = params.value ? params.value.toLowerCase() : "";
    const backgroundColor = sjmColorMap[name]
      ? sjmColorMap[name].backgroundColor
      : "#A3B9FF";

    return {
      backgroundColor: backgroundColor,
      borderRadius: "35%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: "#333",
      fontWeight: "bold",
    };
  };

  const trackerOptions = [
    "AHMED",
    "MOHAMMED B",
    "KHALIL R",
    "MOHAMMED M",
    "MOHAMMED H",
    "KHALIL H",
    "ISSA",
    "ABDULLAH",
    "MOHANAD",
    "SALIM",
    "FRESH",
  ];

  const getTrackerCellStyle = (params) => {
    const trackerColorMap = {
      ahmed: { backgroundColor: "#FFB6C1" },
      "mohammed b": { backgroundColor: "#ADD8E6" },
      "khalil r": { backgroundColor: "#98FB98" },
      "mohammed m": { backgroundColor: "#FAFAD2" },
      "mohammed h": { backgroundColor: "#D8BFD8" },
      "khalil h": { backgroundColor: "#AFEEEE" },
      issa: { backgroundColor: "#D3D3D3" },
      abdullah: { backgroundColor: "#FFFACD" },
      mohanad: { backgroundColor: "#E6E6FA" },
      salim: { backgroundColor: "#E0FFFF" },
      fresh: { backgroundColor: "#FFE4B5" },
    };

    const name = params.value ? params.value.toLowerCase() : "";
    const backgroundColor = trackerColorMap[name]
      ? trackerColorMap[name].backgroundColor
      : "#FFB6C1";

    return {
      backgroundColor: backgroundColor,
      borderRadius: "35%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: "#333",
      fontWeight: "bold",
    };
  };

  const carrierOptions = ["AMLS", "Althaliya", "Ronaq Alsaweh", "Sky"];

  const jpstatusOptions = ["IN TRANSIT", "CLOSED"];

  const getJpstatusCellStyle = (params) => {
    const jpstatusColorMap = {
      "in transit": { backgroundColor: "#D4EDDA", color: "#155724" },
      closed: { backgroundColor: "#FADBD8", color: "#C0392B" },
    };

    const status = params.value ? params.value.toLowerCase() : "";
    const colorConfig = jpstatusColorMap[status] || {
      backgroundColor: "#E5E8E8",
      color: "#5D6D7E",
    };

    return {
      backgroundColor: colorConfig.backgroundColor,
      borderRadius: "35%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: colorConfig.color,
      fontWeight: "bold",
    };
  };

  const regionOptions = ["North", "South", "Haima/Duqm"];
  const getRegionCellStyle = (params) => {
    const regionColorMap = {
      north: { backgroundColor: "#D6EAF8", color: "#1B4F72" },
      south: { backgroundColor: "#D4EDDA", color: "#186A3B" },
      "haima/duqm": { backgroundColor: "#FFF3CD", color: "#856404" },
    };

    const region = params.value ? params.value.toLowerCase() : "";
    const colorConfig = regionColorMap[region] || {
      backgroundColor: "#E2E3E5",
      color: "#5D6D7E",
    };

    return {
      backgroundColor: colorConfig.backgroundColor,
      borderRadius: "35%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: colorConfig.color,
      fontWeight: "bold",
    };
  };

  const bluekeyoptions = ["SAME", "DIFFERENT"];
  const getBlueKeyCellStyle = (params) => {
    const bluekeyColorMap = {
      same: { backgroundColor: "#C8E6C9", color: "#1B5E20" },
      different: { backgroundColor: "#FADBD8", color: "#C0392B" },
    };

    const status = params.value ? params.value.toLowerCase() : "";
    const colorConfig = bluekeyColorMap[status] || {
      backgroundColor: "#E2E3E5",
      color: "#5D6D7E",
    };
    return {
      backgroundColor: colorConfig.backgroundColor,
      borderRadius: "35%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: colorConfig.color,
      fontWeight: "bold",
    };
  };

  const getRemarksCellStyle = (params) => {
    const colorMap = {
      breakdown: "#FFCDD2",
      incident: "#FFCDD2",
      "in rig": "#BBDEFB",
      stopped: "#C8E6C9",
      "back from": "#FFF9C4",
      "ready to close": "#E1BEE7",
      "journey update": "#B2DFDB",
      "going to": "#CFD8DC",
      live: "#FFE0B2",
    };

    const defaultColor = "#F5F5F5";
    const value = params.value ? params.value.toLowerCase() : "";
    const backgroundColor = colorMap[value] || defaultColor;

    return {
      backgroundColor: backgroundColor,
      borderRadius: "35%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: "5px",
      color: "#333333",
      fontWeight: "bold",
    };
  };

  // Fetch active drivers list and store in state
  const fetchActiveDrivers = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_API_URL}/drivers-list`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      const active = (response.data.data || [])
        .filter((d) => d.is_active === "Y")
        .map((d) => ({
          driver_name: d.driver_name,
          reporting_driver_code: d.reporting_driver_code || "",
          driver_id: d.driver_id,
        }));
      setActiveDrivers(active);
    } catch (error) {
      setActiveDrivers([]);
      console.error("Error fetching active drivers:", error);
    }
  };

  // Convert activeDrivers into select compatible options
  const driverOptions = useMemo(
    () =>
      activeDrivers.map((driver) => ({
        value: driver.driver_name,
        label: driver.driver_name,
      })),
    [activeDrivers]
  );

  // Custom React-select based cell editor for Driver Name
  // const DriverCellEditor = (props) => {
  //   const [value, setValue] = useState(
  //     props.value ? { value: props.value, label: props.value } : null
  //   );

  //   const onChange = (selected) => {
  //     setValue(selected);
  //   };

  //   const onBlur = () => {
  //     if (value && value.value !== props.value) {
  //       props.api.stopEditing();
  //       props.node.setDataValue(props.colDef.field, value.value);
  //     } else {
  //       props.api.stopEditing(true);
  //     }
  //   };

  //   return (
  //     <div onBlur={onBlur} tabIndex={-1}>
  //       <Select
  //         autoFocus
  //         defaultValue={value}
  //         options={driverOptions}
  //         onChange={onChange}
  //         menuPlacement="auto"
  //         styles={{ menu: (base) => ({ ...base, zIndex: 9999 }) }}
  //       />
  //     </div>
  //   );
  // };

  const DriverCellEditor = (props) => {
    const [value, setValue] = useState(props.value || "");

    const onBlur = () => {
      if (value !== props.value) {
        props.api.stopEditing();
        props.node.setDataValue(props.colDef.field, value);
      } else {
        props.api.stopEditing(true);
      }
    };

    const onChange = (e) => {
      setValue(e.target.value);
    };

    const onKeyDown = (e) => {
      if (e.key === "Enter") {
        onBlur();
      } else if (e.key === "Escape") {
        props.api.stopEditing(true);
      }
    };

    return (
      <div style={{ width: "100%", height: "100%" }}>
        <input
          autoFocus
          type="text"
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          onKeyDown={onKeyDown}
          list="driverOptionsList"
          style={{
            width: "100%",
            height: "100%",
            border: "none",
            outline: "none",
            padding: "0 8px",
          }}
        />
        <datalist id="driverOptionsList">
          {driverOptions.map((option) => (
            <option key={option.value} value={option.value} />
          ))}
        </datalist>
      </div>
    );
  };

  const handleMainPageClick = async () => {
    if (pendingChanges.length > 0) {
      await handleBatchUpdate();
    }
    navigate("/main");
  };

  const handleColumnChange = (e) => {
    setSelectedColumn(e.target.value);
    setNewValue("");
  };

  const handleValueChange = (e) => {
    setNewValue(e.target.value);
  };

  const handleBulkUpdate = () => {
    if (!selectedColumn || !newValue.trim()) {
      alert("Please select a column and enter a valid value.");
      return;
    }

    if (!columnVisibility[selectedColumn]) {
      alert(`The column "${selectedColumn}" is hidden. Update is not allowed.`);
      return;
    }

    if (!gridRef.current || !gridRef.current.api) {
      alert("Grid is not ready yet!");
      return;
    }

    const selectedRows = gridRef.current.api.getSelectedRows();
    if (selectedRows.length === 0) {
      alert("No rows selected!");
      return;
    }

    if (selectedRows.length > 100) {
      alert("Bulk update is not allowed for more than 100 records.");
      return;
    }

    if (selectedColumn === "jp_status" && newValue === "CLOSED") {
      const invalidRows = selectedRows.filter(
        (row) => row.dfms_check !== "Yes"
      );
      if (invalidRows.length > 0) {
        alert(
          "Cannot set status to CLOSED for rows where DFMS Check is not Yes"
        );
        return;
      }
    }

    // For DRIVER_NAME bulk update: verify newValue is in activeDrivers
    if (selectedColumn === "driver_name") {
      const isValidDriver = activeDrivers.some(
        (driver) =>
          driver.driver_name.toLowerCase() === newValue.trim().toLowerCase()
      );
      if (!isValidDriver) {
        alert("Entered Driver Name is not valid/active.");
        return;
      }
    }

    const updatedRecords = filteredRecords.map((record) => {
      if (selectedRows.some((row) => row.id === record.id)) {
        const updatedRecord = { ...record, [selectedColumn]: newValue };
        if (selectedColumn === "ivms_point" && ivmsPointToRegionMap[newValue]) {
          updatedRecord.region = ivmsPointToRegionMap[newValue];
        }
        return updatedRecord;
      }
      return record;
    });

    setFilteredRecords(updatedRecords);

    setPendingChanges((prev) => [
      ...prev,
      ...selectedRows.map((row) => ({
        id: row.id,
        [selectedColumn]: newValue,
        ...(selectedColumn === "ivms_point" && ivmsPointToRegionMap[newValue]
          ? { region: ivmsPointToRegionMap[newValue] }
          : {}),
      })),
    ]);
    setNewValue("");
    setSelectedColumn("");
  };

  const handleBulkDelete = () => {
    if (!gridRef.current || !gridRef.current.api) {
      alert("Grid is not ready yet!");
      return;
    }

    const selectedRows = gridRef.current.api.getSelectedRows();
    if (selectedRows.length === 0) {
      alert("Please select at least one row to clear accommodation data.");
      return;
    }

    if (selectedRows.length > 100) {
      alert("Bulk delete is limited to 100 records at a time.");
      return;
    }

    if (
      !window.confirm(
        `Clear accommodation for ${selectedRows.length} selected records?`
      )
    ) {
      return;
    }

    const updatedRecords = filteredRecords.map((record) => {
      if (selectedRows.some((row) => row.id === record.id)) {
        return { ...record, accommodation: "" };
      }
      return record;
    });

    setFilteredRecords(updatedRecords);

    setPendingChanges((prev) => [
      ...prev,
      ...selectedRows.map((row) => ({
        id: row.id,
        accommodation: "",
      })),
    ]);
    setMessage(
      `Cleared accommodation for ${selectedRows.length} records. Don't forget to save!`
    );
    setTimeout(() => setMessage(""), 3000);
  };

  const handleBulkDeletePlannedAccommodation = () => {
    if (!gridRef.current || !gridRef.current.api) {
      alert("Grid is not ready yet!");
      return;
    }

    const selectedRows = gridRef.current.api.getSelectedRows();
    if (selectedRows.length === 0) {
      alert(
        "Please select at least one row to clear planned accommodation data."
      );
      return;
    }

    if (selectedRows.length > 100) {
      alert("Bulk delete is limited to 100 records at a time.");
      return;
    }

    if (
      !window.confirm(
        `Clear planned accommodation for ${selectedRows.length} selected records?`
      )
    ) {
      return;
    }

    const updatedRecords = filteredRecords.map((record) => {
      if (selectedRows.some((row) => row.id === record.id)) {
        return { ...record, planned_accommodation: "" };
      }
      return record;
    });

    setFilteredRecords(updatedRecords);

    setPendingChanges((prev) => [
      ...prev,
      ...selectedRows.map((row) => ({
        id: row.id,
        planned_accommodation: "",
      })),
    ]);

    setMessage(
      `Cleared planned accommodation for ${selectedRows.length} records. Don't forget to save!`
    );
    setTimeout(() => setMessage(""), 3000);
  };

  const fetchRecords = async (lastModifiedRowId = null) => {
    try {
      setIsLoading(true);
      const token = localStorage.getItem("token");

      // Cancel previous request if it exists
      if (fetchController.current) {
        fetchController.current.abort();
      }
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_API_URL}/modifyFetch`,
        {
          headers: { Authorization: `Bearer ${token}` },
          params: { status: selectedStatus },
        }
      );

      const records = response.data.results || [];
      setOriginalRecords(records);
      applyFilters(records);

      if (lastModifiedRowId) {
        moveRowToTop(lastModifiedRowId);
      }
    } catch (error) {
      console.error("Error fetching records:", error);
      setMessage("Error fetching records. Please try again.");
      setTimeout(() => {
        setMessage("");
      }, 3000);
    } finally {
      setIsLoading(false);
    }
  };
  const fetchController = useRef(null);
  useEffect(() => {
  const debounceTimer = setTimeout(() => {
    fetchRecords();
  }, 300); 

  return () => {
    clearTimeout(debounceTimer);
    if (fetchController.current) {
      fetchController.current.abort();
    }
  };
}, [selectedStatus]);

  const remarksoptions = ["live", "stopped"];
  const applyFilters = (records) => {
    const statusFiltered = records.filter(
      (record) =>
        record.jp_status?.toLowerCase() === selectedStatus.toLowerCase()
    );
    setFilteredRecords(statusFiltered);
    setJourneyCount(statusFiltered.length);
  };

  const debounce = (func, delay) => {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        func.apply(this, args);
      }, delay);
    };
  };

  const saveFilterState = (filterModel) => {
    localStorage.setItem("gridFilterState", JSON.stringify(filterModel));
  };

  const handleGridFilterChange = debounce((event) => {
    const filterModel = event.api.getFilterModel();
    saveFilterState(filterModel);

    const filteredData = originalRecords.filter((record) => {
      const statusMatch =
        (record.jp_status || record.JP_STATUS || "")
          .toString()
          .toLowerCase() === selectedStatus.toLowerCase();

      const dateFilter = filterModel["journey_plane_date"] || filterModel["JOURNEY_PLANE_DATE"];
      let dateMatch = true;
      if (dateFilter) {
        const { dateFrom, type } = dateFilter;
        const recordDate = new Date(record.journey_plane_date || record.JOURNEY_PLANE_DATE);
        const normalizedRecordDate = new Date(recordDate.setHours(0, 0, 0, 0));

        const fromDate = new Date(dateFrom);
        const normalizedFromDate = new Date(fromDate.setHours(0, 0, 0, 0));

        if (type === "equals") {
          dateMatch =
            normalizedRecordDate.getTime() === normalizedFromDate.getTime();
        }
      }

      const gridMatch = Object.keys(filterModel).every((field) => {
        if (field.toLowerCase() !== "journey_plane_date") {
          const filterValue = filterModel[field]?.filter;
          if (!filterValue) return true;
          const recordValue =
            record[field] ?? record[field.toUpperCase()] ?? record[field.toLowerCase()];
          return recordValue
            ? recordValue
                .toString()
                .toLowerCase()
                .includes(filterValue.toLowerCase())
            : false;
        }
        return dateMatch;
      });

      return statusMatch && gridMatch;
    });

    setFilteredRecords(filteredData);
    setJourneyCount(filteredData.length);
  }, 300);

  const restoreFilterState = (api) => {
    try {
      const savedFilterState = localStorage.getItem("gridFilterState");
      if (savedFilterState && savedFilterState !== "undefined") {
        const filterModel = JSON.parse(savedFilterState);
        api.setFilterModel(filterModel);
      } else {
        api.setFilterModel(null);
      }
    } catch (error) {
      console.warn("Error restoring filter state:", error);
      api.setFilterModel(null);
    }
  };

  useEffect(() => {
    setJourneyCount(
      originalRecords.filter((record) => {
        const status =
          (record.jp_status || record.JP_STATUS || "").toString().toLowerCase();
        return status === (selectedStatus || "").toLowerCase();
      }).length
    );
  }, [selectedStatus, originalRecords]);

  useEffect(() => {
    fetchActiveDrivers();
    fetchDriverRestStatus();
  }, []);

  useEffect(() => {
    if (pendingChanges.length > 0) {
      setTimer(60);
      setTimerActive(true);
    } else {
      setTimer(0);
      setTimerActive(false);
    }
  }, [pendingChanges]);

  useEffect(() => {
    if (timerActive) {
      const interval = setInterval(() => {
        setTimer((prevTimer) => {
          if (prevTimer <= 1) {
            clearInterval(interval);
            if (pendingChanges.length > 0) {
              handleBatchUpdate();
            }
            return 0;
          }
          return prevTimer - 1;
        });
      }, 1000);

      return () => clearInterval(interval);
    }
  }, [timerActive, pendingChanges]);

  const handleChanges = (params) => {
    // Handle ivms_point changes
    if (params.colDef.field === "ivms_point" && params.newValue) {
      const region = ivmsPointToRegionMap[params.newValue];
      if (region) {
        const updatedRecord = { ...params.data, region: region };
        const rowNode = gridRef.current.api.getRowNode(params.data.id);
        if (rowNode) {
          rowNode.setDataValue("region", region);
        }
      }
    }

    if (
      params.colDef.field === "driver_name" &&
      params.newValue !== params.oldValue
    ) {
      const validDriver = activeDrivers.some(
        (drv) => drv.driver_name.toLowerCase() === params.newValue.toLowerCase()
      );
      if (!validDriver) {
        setMessage("Selected driver is not active or valid");
        setTimeout(() => setMessage(""), 3000);
        if (gridRef.current && gridRef.current.api) {
          const rowNode = gridRef.current.api.getRowNode(params.data.id);
          if (rowNode) {
            rowNode.setDataValue("driver_name", params.oldValue);
          }
        }
        return;
      }
    }

    const updatedRecords = filteredRecords.map((record) =>
      record.id === params.data.id
        ? { ...record, [params.colDef.field]: params.newValue }
        : record
    );

    setFilteredRecords(updatedRecords);

    setPendingChanges((prev) => {
      const existingChangeIndex = prev.findIndex(
        (change) => change.id === params.data.id
      );
      if (existingChangeIndex >= 0) {
        const existingChange = prev[existingChangeIndex];
        return [
          ...prev.slice(0, existingChangeIndex),
          {
            ...existingChange,
            [params.colDef.field]: params.newValue,
            ...(params.colDef.field === "ivms_point" &&
            ivmsPointToRegionMap[params.newValue]
              ? { region: ivmsPointToRegionMap[params.newValue] }
              : {}),
          },
          ...prev.slice(existingChangeIndex + 1),
        ];
      } else {
        return [
          ...prev,
          {
            id: params.data.id,
            [params.colDef.field]: params.newValue,
            ...(params.colDef.field === "ivms_point" &&
            ivmsPointToRegionMap[params.newValue]
              ? { region: ivmsPointToRegionMap[params.newValue] }
              : {}),
          },
        ];
      }
    });
  };

  const moveRowToTop = (id) => {
    if (gridRef.current && gridRef.current.api) {
      gridRef.current.api.setSortModel([]);
      const rowIndex = filteredRecords.findIndex((record) => record.id === id);
      if (rowIndex >= 0) {
        const updatedRow = filteredRecords[rowIndex];
        const updatedRecords = [
          updatedRow,
          ...filteredRecords.filter((record) => record.id !== id),
        ];
        setFilteredRecords(updatedRecords);
      }
    }
  };

  const isJourneyUpdatable = (journeyDateStr) => {
    if (!journeyDateStr) return false;
    // Parse without UTC, treat as local time
    const journeyDate = moment(journeyDateStr, "DD MMM YYYY HH:mm", true);
    // Define local cutoff moment at midnight of Aug 24, 2025
    const cutoff = moment("24 Aug 2025 00:00", "DD MMM YYYY HH:mm", true);

    // Compare dates
    return journeyDate.isValid() && journeyDate.isSameOrAfter(cutoff);
  };

  const handleBatchUpdate = async (e) => {
    if (e) e.preventDefault();

    if (!pendingChanges.length) {
      setMessage("No changes to update.");
      setTimeout(() => setMessage(""), 3000);
      return;
    }

    if (pendingChanges.length > 100) {
      setMessage("Update limited to 100 records at a time.");
      setTimeout(() => setMessage(""), 3000);
      return;
    }

    const token = localStorage.getItem("token");

    try {
      // Save all changes as usual
      const dataToUpdate = pendingChanges.map((change) => {
        const obj = { id: change.id };
        for (const key in change) {
          if (key !== "id") {
            obj[key] = change[key];
          }
        }
        return obj;
      });

      await axios.patch(
        `${process.env.REACT_APP_BASE_API_URL}/modifyRecordsBatch`,
        dataToUpdate,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      // Process assign-driver and complete-journey only for allowed dates
      for (const change of pendingChanges) {
        const row =
          filteredRecords.find((r) => r.id === change.id) ||
          originalRecords.find((r) => r.id === change.id) ||
          {};
        const journeyDateStr = formatDateTime(row.journey_plane_date || row.JOURNEY_PLANE_DATE || ""); // Format the date
        console.log("Journey Date:", journeyDateStr);
        if (!isJourneyUpdatable(journeyDateStr)) {
          // Skip calls for old date journeys
          continue;
        }

        const journeyPlanNo =
          change.journey_plane_no || change.JOURNEY_PLANE_NO || row.journey_plane_no || row.JOURNEY_PLANE_NO || null;

        if (
          (Object.prototype.hasOwnProperty.call(change, "driver_name") || Object.prototype.hasOwnProperty.call(change, "DRIVER_NAME")) &&
          journeyPlanNo &&
          (change.driver_name || change.DRIVER_NAME)
        ) {
          try {
            await axios.post(
              `${process.env.REACT_APP_BASE_API_URL}/api/assign-driver`,
              {
                journey_plane_no: journeyPlanNo,
                driver_name: change.driver_name || change.DRIVER_NAME,
              },
              { headers: { Authorization: `Bearer ${token}` } }
            );
            await fetchDriverRestStatus();
          } catch (error) {
            console.error("Assign driver error:", error);
          }
        }
        if (
          (Object.prototype.hasOwnProperty.call(change, "jp_status") || Object.prototype.hasOwnProperty.call(change, "JP_STATUS")) &&
          journeyPlanNo &&
          ((change.jp_status || change.JP_STATUS) === "CLOSED")
        ) {
          try {
            await axios.post(
              `${process.env.REACT_APP_BASE_API_URL}/api/complete-driver-journey`,
              {
                journeyPlanNo,
                endDate: new Date().toISOString(),
              },
              { headers: { Authorization: `Bearer ${token}` } }
            );
          } catch (error) {
            console.error("Complete journey error:", error);
          }
        }
      }

      setMessage("Update successful!");
      setTimeout(() => setMessage(""), 3000);
      const lastId = pendingChanges[pendingChanges.length - 1].id;

      setPendingChanges([]);

      setFilteredRecords((prev) => {
        const updated = prev.map((rec) => {
          const change = pendingChanges.find((ch) => ch.id === rec.id);
          return change ? { ...rec, ...change } : rec;
        });
        // Move last modified row to top
        const idx = updated.findIndex((rec) => rec.id === lastId);
        if (idx >= 0) {
          const lastMod = updated[idx];
          return [lastMod, ...updated.filter((_, i) => i !== idx)];
        }
        return updated;
      });
    } catch (error) {
      setMessage(error.response?.data?.message || "Error during update.");
      setTimeout(() => setMessage(""), 3000);
    }
  };

  const onGridReady = (params) => {
    gridRef.current = params.api;
    if (gridRef.current) {
      gridRef.current.api = params.api;
    }
    restoreFilterState(params.api);
  };

  const clearFilterState = () => {
    localStorage.removeItem("gridFilterState");
    if (gridRef.current && gridRef.current.api) {
      gridRef.current.api.setFilterModel(null);
    }
  };

  const resetFilters = () => {
    setSelectedStatus("IN TRANSIT");
    applyFilters(originalRecords);
    if (gridRef.current) {
      gridRef.current.api.setFilterModel(null);
    }
    clearFilterState();
  };

  const formatDateTime = (dateString) => {
    if (!dateString) return "";
    const date = moment(dateString);
    return date.isValid() ? date.format("DD MMM YYYY HH:mm") : "Invalid Date";
  };

  const DatePickerCellEditor = (props) => {
    const [date, setDate] = useState(null);
    const [initialDate, setInitialDate] = useState(null);
    const flatpickrRef = useRef(null);

    useEffect(() => {
      if (props.value) {
        const parsedDate = moment(props.value).toDate();
        setDate(parsedDate);
        setInitialDate(parsedDate);
      }
    }, [props.value]);

    const onClose = (selectedDates) => {
      if (selectedDates && selectedDates.length) {
        const selectedDate = selectedDates[0];
        if (!moment(selectedDate).isSame(initialDate)) {
          const formattedDate = moment(selectedDate).utc().format();
          setDate(selectedDate);
          props.onDateChange(formattedDate);
          props.stopEditing();
        }
      }
    };
    return (
      <div
        onBlur={(e) => {
          // Intentional empty block - keeping picker open
        }}
        tabIndex={-1}
      >
        <Flatpickr
          ref={flatpickrRef}
          value={date}
          onClose={onClose}
          options={{
            enableTime: true,
            dateFormat: "d M Y H:i",
            time_24hr: true,
            allowInput: true,
            clickOpens: true,
            closeOnSelect: false,
            enableMobile: false,
            plugins: [confirmDatePlugin({})],
          }}
          className="small-flatpickr"
        />
      </div>
    );
  };

  const LastCheckTimeCellEditor = (props) => {
    const [date, setDate] = useState(
      props.value ? moment(props.value).toDate() : new Date()
    );
    const flatpickrRef = useRef(null);

    useEffect(() => {
      if (props.value) {
        const parsedDate = moment(props.value).toDate();
        setDate(parsedDate);
      }
    }, [props.value]);

    const handleReady = (selectedDates, dateStr, instance) => {
      instance.set("maxDate", new Date());
      const now = new Date();
      if (moment(date).isSame(now, "day")) {
        instance.set("maxTime", now);
      }

      const addTodayButton = () => {
        let confirmContainer =
          instance.calendarContainer?.querySelector(".flatpickr-confirm");

        if (!confirmContainer) {
          confirmContainer = document.createElement("div");
          confirmContainer.className = "flatpickr-confirm";
          confirmContainer.style.cssText = `
            display: flex;
            justify-content: space-between;
            padding: 8px;
            border-top: 1px solid #e6e6e6;
            background: #fafafa;
          `;

          const calendarContainer = instance.calendarContainer;
          if (calendarContainer) {
            calendarContainer.appendChild(confirmContainer);
          }
        }

        const existingTodayBtn = confirmContainer.querySelector(".today-btn");
        if (existingTodayBtn) {
          existingTodayBtn.remove();
        }

        // Create Today button
        const todayButton = document.createElement("button");
        todayButton.className = "today-btn";
        todayButton.type = "button";
        todayButton.textContent = "Current Time";
        todayButton.style.cssText = `
          background: #28a745;
          color: white;
          border: none;
          padding: 8px 16px;
          border-radius: 4px;
          cursor: pointer;
          font-size: 12px;
          font-weight: bold;
          margin-right: 8px;
        `;

        todayButton.addEventListener("click", () => {
          const now = new Date();
          instance.setDate(now, true);

          const formattedDate = moment(now).utc().format();

          setDate(now);

          if (props.onDateChange) {
            props.onDateChange(formattedDate);
          }

          props.stopEditing();
        });

        let okButton = confirmContainer.querySelector(".confirm-btn");
        if (!okButton) {
          okButton = document.createElement("button");
          okButton.className = "confirm-btn";
          okButton.type = "button";
          okButton.textContent = "OK";
          okButton.style.cssText = `
            background: #007bff;
            color: white;
            border: none;
            padding: 8px 16px;
            border-radius: 4px;
            cursor: pointer;
            font-size: 12px;
            font-weight: bold;
          `;

          okButton.addEventListener("click", () => {
            const currentDate = instance.selectedDates[0];
            if (currentDate) {
              const formattedDate = moment(currentDate).utc().format();
              if (props.onDateChange) {
                props.onDateChange(formattedDate);
              }
            }
            instance.close();
            props.stopEditing();
          });
        }

        confirmContainer.innerHTML = "";
        confirmContainer.appendChild(todayButton);
        confirmContainer.appendChild(okButton);
      };

      setTimeout(addTodayButton, 50);
      setTimeout(addTodayButton, 200);
      setTimeout(addTodayButton, 500);
    };

    const handleChange = (selectedDates) => {
      if (selectedDates && selectedDates.length) {
        const selectedDate = selectedDates[0];
        const now = new Date();

        if (selectedDate > now) {
          alert(
            "Last Check Time cannot be in the future. Please select a past date and time."
          );
          flatpickrRef.current.flatpickr.setDate(date, false);
          return;
        }

        setDate(selectedDate);
      }
    };

    const handleClose = (selectedDates) => {
      if (selectedDates && selectedDates.length) {
        const selectedDate = selectedDates[0];
        const now = new Date();

        if (selectedDate > now) {
          alert("Cannot save future time! Please select a past date and time.");
          props.stopEditing(true);
          return;
        }

        const formattedDate = moment(selectedDate).utc().format();
        props.onDateChange(formattedDate);
        props.stopEditing();
      } else {
        props.stopEditing(true);
      }
    };

    return (
      <div style={{ width: "100%", height: "100%" }}>
        <Flatpickr
          ref={flatpickrRef}
          value={date}
          onChange={handleChange}
          onClose={handleClose}
          onReady={handleReady}
          options={{
            enableTime: true,
            dateFormat: "d M Y H:i",
            time_24hr: true,
            allowInput: true,
            clickOpens: true,
            closeOnSelect: false,
            enableMobile: true,
            minuteIncrement: 1,
            maxDate: new Date(),
            disable: [
              function (date) {
                const now = new Date();
                if (
                  date.getDate() === now.getDate() &&
                  date.getMonth() === now.getMonth() &&
                  date.getFullYear() === now.getFullYear()
                ) {
                  return date > now;
                }
                return date > now;
              },
            ],
            plugins: [confirmDatePlugin({})],
          }}
          className="small-flatpickr"
          style={{
            width: "100%",
            height: "100%",
            border: "2px solid #007bff",
            background: "white",
            padding: "0 8px",
          }}
        />
      </div>
    );
  };
  const getNextPointCellStyle = (params) => {
    const nextPointValue = params.value?.trim().toLowerCase();
    if (nextPointValue === "duqm") {
      return {
        backgroundColor: "lightgreen",
        textAlign: "center",
        borderTop: "1px solid #4CAF50",
        borderBottom: "1px solid #4CAF50",
      };
    } else {
      return { textAlign: "center" };
    }
  };

  const nextPointOptions = ["Wadi Saa", "Dhank", "Ibri", "Fahud"];
  
  const ivmsPointOptions = [
    "Sohar",
    "Wadi Al-jizzi",
    "AlBuraimi",
    "Wadi Saa",
    "As Sunainah",
    "Dhank",
    "Ibri",
    "Hamra Aldrooa",
    "Natih",
    "Fahud",
  ];

  const ivmsBrandOptions = [
    "FMSI Almadina",
    "FMSI DHL",
    "FMSI Oman",
    "FMSI Almukhtar",
    "HilatTech",
    "GTrackit",
    "FMSTech",
    "Tracer",
    "KginfoTech",
    "CueTrans",
  ];

  const plannedAccommodationOptions = [
    "Haima??",
    "Nimr??",
    "Fahud??",
    "Ghaba??",
    "Marmul??",
    "QarnAlam??",
    "Duqm??",
    "Rig??",
    "Haima",
    "Nimr",
    "Fahud",
    "Ghaba",
    "Marmul",
    "QarnAlam",
    "PASSENGER",
    "",
  ];

  const confirmedBookingsOptions = [
    "Haima - Omani",
    "Nimr - Omani",
    "Fahud - Omani",
    "Ghaba - Omani",
    "Marmul - Omani",
    "QarnAlam - Omani",
    "Duqm - Omani",
    "Rig - Omani",
    "Haima - Omani - Own",
    "Nimr - Omani - Own",
    "Fahud - Omani - Own",
    "Ghaba - Omani - Own",
    "Marmul - Omani - Own",
    "QarnAlam - Omani - Own",
    "Duqm - Omani - Own",
  ];

  const confirmedMapping = {
    "": [],
    Haima: ["Haima - Omani", "Haima - Omani - Own"],
    "Haima??": ["Haima - Omani", "Haima - Omani - Own"],
    Nimr: ["Nimr - Omani", "Nimr - Omani - Own"],
    "Nimr??": ["Nimr - Omani", "Nimr - Omani - Own"],
    Fahud: ["Fahud - Omani", "Fahud - Omani - Own"],
    "Fahud??": ["Fahud - Omani", "Fahud - Omani - Own"],
    Ghaba: ["Ghaba - Omani", "Ghaba - Omani - Own"],
    "Ghaba??": ["Ghaba - Omani", "Ghaba - Omani - Own"],
    Marmul: ["Marmul - Omani", "Marmul - Omani - Own"],
    "Marmul??": ["Marmul - Omani", "Marmul - Omani - Own"],
    QarnAlam: ["QarnAlam - Omani", "QarnAlam - Omani - Own"],
    "QarnAlam??": ["QarnAlam - Omani", "QarnAlam - Omani - Own"],
    Duqm: ["Duqm - Omani", "Duqm - Omani - Own"],
    "Duqm??": ["Duqm - Omani", "Duqm - Omani - Own"],
    Rig: ["Rig - Omani", "Rig - Omani - Own"],
    "Rig??": ["Rig - Omani", "Rig - Omani - Own"],
  };

  const [columnVisibility, setColumnVisibility] = useState({
    tracker: true,
    journey_plane_no: true,
    scheduled_vehicle: true,
    carrier: true,
    remarks: true,
    jp_status: true,
    next_arrival_date: true,
    next_point: true,
    ivms_check_date: true,
    ivms_point: true,
    ivms_brand: true,
    driver_name: true,
    offload_point: true,
    region: true,
    accommodation: true,
    blue_key_name: true,
    sjm: true,
    journey_plane_date: true,
    dfms_check: true,
    planned_accommodation: true,
  });

  const columns = useMemo(
    () => [
      {
        headerCheckboxSelection: true,
        checkboxSelection: true,
        width: 10,
        hide: !columnVisibility.journey_plane_no,
      },
      {
        headerName: "Tracker",
        field: "tracker",
        filter: true,
        editable: true,
        cellEditor: "agSelectCellEditor",
        width: 130,
        cellEditorParams: {
          values: trackerOptions,
        },
        cellStyle: getTrackerCellStyle,
        hide: !columnVisibility.tracker,
      },
      {
        headerName: "JP No",
        field: "journey_plane_no",
        filter: true,
        editable: true,
        width: 90,
        cellStyle: { fontWeight: "bold" },
        hide: !columnVisibility.journey_plane_no,
      },
      {
        headerName: "Scheduled Vehicle",
        field: "scheduled_vehicle",
        filter: true,
        editable: true,
        width: 90,
        hide: !columnVisibility.scheduled_vehicle,
      },
      {
        headerName: "Carrier",
        field: "carrier",
        filter: true,
        editable: true,
        cellEditor: "agSelectCellEditor",
        width: 60,
        cellEditorParams: {
          values: carrierOptions,
        },
        hide: !columnVisibility.carrier,
      },
      {
        headerName: "Remarks",
        field: "remarks",
        filter: true,
        editable: true,
        cellEditor: "agSelectCellEditor",
        width: 100,
        cellEditorParams: {
          values: remarksoptions,
        },
        cellStyle: getRemarksCellStyle,
        hide: !columnVisibility.remarks,
      },
      {
        headerName: "JP STATUS",
        field: "jp_status",
        filter: true,
        editable: true,
        cellEditor: "agSelectCellEditor",
        width: 100,
        cellEditorParams: {
          values: jpstatusOptions,
        },
        cellStyle: getJpstatusCellStyle,
        hide: !columnVisibility.jp_status,
      },
      // {
      //   headerName: "Next Arrival Time",
      //   field: "NEXT_ARRIVAL_DATE",
      //   valueGetter: (params) => {
      //     const rawDate = params.data.NEXT_ARRIVAL_DATE;
      //     return rawDate ? moment(rawDate).valueOf() : null;
      //   },
      //   valueFormatter: (params) =>
      //     formatDateTime(params.data.NEXT_ARRIVAL_DATE),
      //   editable: true,
      //   width: 145,
      //   filter: "agDateColumnFilter",
      //   filterParams: {
      //     comparator: (filterLocalDateAtMidnight, cellValue) => {
      //       if (!cellValue) return -1;
      //       const cellDate = moment(cellValue).startOf("day");
      //       const filterDate = moment(filterLocalDateAtMidnight).startOf("day");
      //       if (cellDate.isBefore(filterDate)) return -1;
      //       if (cellDate.isAfter(filterDate)) return 1;
      //       return 0;
      //     },
      //     parseDate: (dateString) =>
      //       moment(dateString, [
      //         "DD MMM YYYY",
      //         "YYYY-MM-DD",
      //         "DD MMM YYYY HH:mm",
      //       ]).toDate(),
      //   },
      //   cellEditor: DatePickerCellEditor,
      //   cellEditorParams: (params) => ({
      //     onDateChange: (newValue) => {
      //       const updatedRecord = filteredRecords.find(
      //         (record) => record.id === params.data.id
      //       );
      //       handleChanges({
      //         data: updatedRecord,
      //         rowIndex: params.rowIndex,
      //         colDef: { field: "NEXT_ARRIVAL_DATE" },
      //         newValue: newValue,
      //       });
      //     },
      //   }),
      //   hide: !columnVisibility.NEXT_ARRIVAL_DATE,
      // },
      {
        headerName: "Next Point",
        field: "next_point",
        filter: true,
        cellEditor: "agSelectCellEditor",
        editable: true,
        width: 90,
        cellEditorParams: {
          values: nextPointOptions,
        },
        cellStyle: getNextPointCellStyle,
        hide: !columnVisibility.next_point,
      },
      // {
      //   headerName: "Last Check Time",
      //   field: "IVMS_CHECK_DATE",
      //   valueGetter: (params) => {
      //     const rawDate = params.data.IVMS_CHECK_DATE;
      //     return rawDate ? moment(rawDate).valueOf() : null;
      //   },
      //   valueFormatter: (params) => formatDateTime(params.data.IVMS_CHECK_DATE),
      //   editable: true,
      //   width: 145,
      //   filter: "agDateColumnFilter",
      //   filterParams: {
      //     comparator: (filterLocalDateAtMidnight, cellValue) => {
      //       if (!cellValue) return -1;
      //       const cellDate = moment(cellValue).startOf("day");
      //       const filterDate = moment(filterLocalDateAtMidnight).startOf("day");
      //       if (cellDate.isBefore(filterDate)) return -1;
      //       if (cellDate.isAfter(filterDate)) return 1;
      //       return 0;
      //     },
      //     parseDate: (dateString) =>
      //       moment(dateString, [
      //         "DD MMM YYYY",
      //         "YYYY-MM-DD",
      //         "DD MMM YYYY HH:mm",
      //       ]).toDate(),
      //   },
      //   cellEditor: DatePickerCellEditor,
      //   cellEditorParams: (params) => ({
      //     onDateChange: (newValue) => {
      //       const updatedRecord = filteredRecords.find(
      //         (record) => record.id === params.data.id
      //       );
      //       handleChanges({
      //         data: updatedRecord,
      //         rowIndex: params.rowIndex,
      //         colDef: { field: "IVMS_CHECK_DATE" },
      //         newValue: newValue,
      //       });
      //     },
      //   }),
      //   hide: !columnVisibility.IVMS_CHECK_DATE,
      // },
      {
        headerName: "Last Check Time",
        field: "ivms_check_date",
        valueGetter: (params) => {
          const rawDate = params.data.ivms_check_date;
          return rawDate ? moment(rawDate).valueOf() : null;
        },
        valueFormatter: (params) => formatDateTime(params.data.ivms_check_date),
        editable: true,
        width: 145,
        filter: "agDateColumnFilter",
        filterParams: {
          comparator: (filterLocalDateAtMidnight, cellValue) => {
            if (!cellValue) return -1;
            const cellDate = moment(cellValue).startOf("day");
            const filterDate = moment(filterLocalDateAtMidnight).startOf("day");
            if (cellDate.isBefore(filterDate)) return -1;
            if (cellDate.isAfter(filterDate)) return 1;
            return 0;
          },
          parseDate: (dateString) =>
            moment(dateString, [
              "DD MMM YYYY",
              "YYYY-MM-DD",
              "DD MMM YYYY HH:mm",
            ]).toDate(),
        },
        cellEditor: LastCheckTimeCellEditor,
        cellEditorParams: (params) => ({
          onDateChange: (newValue) => {
            // Find the record and trigger the change
            const updatedRecord = filteredRecords.find(
              (record) => record.id === params.data.id
            );
            if (updatedRecord) {
              handleChanges({
                data: updatedRecord,
                rowIndex: params.rowIndex,
                colDef: { field: "ivms_check_date" },
                newValue: newValue,
                oldValue: params.data.ivms_check_date,
              });
            }
          },
        }),
        hide: !columnVisibility.ivms_check_date,
      },
      {
        headerName: "Last IVMS Point",
        field: "ivms_point",
        filter: true,
        editable: true,
        cellEditor: "agSelectCellEditor",
        width: 90,
        cellEditorParams: {
          values: ivmsPointOptions,
        },
        onCellValueChanged: (params) => {
          if (params.newValue && params.data) {
            const region = ivmsPointToRegionMap[params.newValue];
            if (region) {
              const updatedRecord = { ...params.data, region: region };
              setFilteredRecords((records) =>
                records.map((record) =>
                  record.id === params.data.id ? updatedRecord : record
                )
              );
              setPendingChanges((prev) => [
                ...prev,
                {
                  id: params.data.id,
                  ivms_point: params.newValue,
                  region: region,
                },
              ]);
            }
          }
        },
        hide: !columnVisibility.ivms_point,
      },
      // {
      //   headerName: "IVMS Brand",
      //   field: "IVMS_BRAND",
      //   filter: true,
      //   editable: true,
      //   cellEditor: "agSelectCellEditor",
      //   width: 120,
      //   cellEditorParams: {
      //     values: ivmsBrandOptions,
      //   },
      //   hide: !columnVisibility.IVMS_BRAND,
      // },
      {
        headerName: "Driver Name",
        field: "driver_name",
        filter: true,
        editable: true,
        width: 240,
        // Use custom cell editor for driver name dropdown
        cellEditor: DriverCellEditor,
        cellRenderer: (params) => {
          const status = driverRestStatus[params.value];
          const needsRest = status?.needs_rest;
          const tooltip = needsRest
            ? `Driver has worked ${
                status?.consecutive_work_days
              } consecutive days. Last rest: ${
                status?.last_rest_date || "Never"
              }`
            : "Driver is within rest limits";
          return (
            <div
              className="driver-cell"
              onContextMenu={(e) => {
                e.preventDefault();
                setSelectedDriver(params.value);
                setShowRestModal(true);
              }}
              data-tooltip-id={`driver-tt-${params.value}`}
              data-tooltip-content={tooltip}
            >
              <span className={needsRest ? "text-danger font-weight-bold" : ""}>
                {params.value}
                {needsRest && " ⚠️"}
              </span>
              <Tooltip id={`driver-tt-${params.value}`} />
            </div>
          );
        },
        hide: !columnVisibility.driver_name,
      },
      {
        headerName: "Offload Point",
        field: "offload_point",
        filter: true,
        editable: true,
        width: 80,
        hide: !columnVisibility.offload_point,
      },
      // {
      //   headerName: "Region",
      //   field: "region",
      //   filter: true,
      //   editable: true,
      //   cellEditor: "agSelectCellEditor",
      //   width: 100,
      //   cellEditorParams: {
      //     values: regionOptions,
      //   },
      //   cellStyle: getRegionCellStyle,
      //   hide: !columnVisibility.region,
      // },
      // {
      //   headerName: "Planned Accommodation",
      //   field: "planned_accommodation",
      //   filter: true,
      //   editable: true,
      //   width: 150,
      //   cellEditor: "agSelectCellEditor",
      //   cellEditorParams: {
      //     values: plannedAccommodationOptions,
      //   },
      //   hide: false,
      // },
      // {
      //   headerName: "Confirmed bookings",
      //   field: "accommodation",
      //   filter: true,
      //   editable: true,
      //   width: 180,
      //   cellEditor: "agSelectCellEditor",
      //   cellEditorParams: (params) => {
      //     const plannedValue = params.data.planned_accommodation;
      //     const allowedOptions = Object.prototype.hasOwnProperty.call(
      //       confirmedMapping,
      //       plannedValue
      //     )
      //       ? confirmedMapping[plannedValue]
      //       : confirmedBookingsOptions;
      //     return {
      //       values: allowedOptions,
      //     };
      //   },
      //   hide: !columnVisibility.accommodation,
      // },
      {
        headerName: "Blue Key Name",
        field: "blue_key_name",
        filter: true,
        editable: true,
        cellEditor: "agSelectCellEditor",
        width: 100,
        cellEditorParams: {
          values: bluekeyoptions,
        },
        cellStyle: getBlueKeyCellStyle,
        hide: !columnVisibility.blue_key_name,
      },
      {
        headerName: "SJM",
        field: "sjm",
        filter: true,
        editable: true,
        cellEditor: "agSelectCellEditor",
        width: 125,
        cellEditorParams: {
          values: sjmOptions,
        },
        cellStyle: getSjmCellStyle,
        hide: !columnVisibility.sjm,
      },
      {
        headerName: "Journey Date",
        field: "journey_plane_date",
        valueGetter: (params) => {
          const rawDate = params.data.journey_plane_date;
          const parsedDate = rawDate ? moment(rawDate) : null;
          return parsedDate && parsedDate.isValid()
            ? parsedDate.valueOf()
            : null;
        },
        valueFormatter: (params) => {
          const momentDate = moment(params.value);
          if (momentDate.isValid()) {
            return momentDate.format("DD MMM YYYY HH:mm");
          }
          return "Invalid Date";
        },
        editable: true,
        width: 110,
        filter: "agDateColumnFilter",
        filterParams: {
          comparator: (filterLocalDateAtMidnight, cellValue) => {
            if (!cellValue) return -1;
            const cellDate = moment(cellValue).startOf("day");
            const filterDate = moment(filterLocalDateAtMidnight).startOf("day");
            if (cellDate.isBefore(filterDate)) return -1;
            if (cellDate.isAfter(filterDate)) return 1;
            return 0;
          },
          parseDate: (dateString) =>
            moment(dateString, [
              "DD MMM YYYY",
              "YYYY-MM-DD",
              "DD MMM YYYY HH:mm",
            ]).toDate(),
        },
        cellEditor: DatePickerCellEditor,
        cellEditorParams: (params) => ({
          onDateChange: (newValue) => {
            const updatedRecord = filteredRecords.find(
              (record) => record.id === params.data.id
            );
            handleChanges({
              data: updatedRecord,
              rowIndex: params.rowIndex,
              colDef: { field: "journey_plane_date" },
              newValue: newValue,
            });
          },
        }),
        hide: !columnVisibility.journey_plane_date,
      },
      {
        headerName: "DFMS Check",
        field: "dfms_check",
        filter: true,
        editable: true,
        width: 100,
        cellEditor: "agSelectCellEditor",
        cellEditorParams: {
          values: ["Yes", "No"],
        },
        valueFormatter: (params) => params.value || "",
        hide: !columnVisibility.dfms_check,
      },
    ],
    [
      dropdownData,
      filteredRecords,
      sjmOptions,
      trackerOptions,
      carrierOptions,
      jpstatusOptions,
      regionOptions,
      remarksoptions,
      bluekeyoptions,
      nextPointOptions,
      ivmsPointOptions,
      ivmsBrandOptions,
      columnVisibility,
      highlightedRows,
      plannedAccommodationOptions,
      confirmedBookingsOptions,
      driverRestStatus,
      driverOptions,
    ]
  );

  const defaultColDef = useMemo(
    () => ({
      editable: true,
      enableCellChangeFlash: true,
      suppressMovable: true,
      resizable: true,
      sortable: true,
      filter: true,
    }),
    []
  );

  const handleStatusChange = async (status) => {
    setSelectedStatus(status);
    setFilteredRecords([]);
    setIsLoading(true);
  };

  const onSelectionChanged = () => {
    if (gridRef.current && gridRef.current.api) {
      const selectedRows = gridRef.current.api.getSelectedRows();
      setSelectedRowsCount(selectedRows.length);
    }
  };

  const handleCellContextMenu = (params) => {
    params.event.preventDefault();
    setHighlightedRows((prev) => {
      const newHighlighted = new Set(prev);
      if (newHighlighted.has(params.node.data.id)) {
        newHighlighted.delete(params.node.data.id);
      } else {
        newHighlighted.add(params.node.data.id);
      }
      localStorage.setItem(
        "highlightedRows",
        JSON.stringify([...newHighlighted])
      );
      return newHighlighted;
    });
  };

  const getRowStyle = (params) => {
    if (!params.data) return null;

    const isHighlighted = highlightedRows.has(params.data.id);

    if (isHighlighted) {
      return { backgroundColor: "#FFB74D" };
    }

    return null;
  };

  const getRowId = (params) => {
    return String(params.data.id);
  };

  useEffect(() => {
    const savedVisibility = localStorage.getItem("columnVisibilityState");
    if (savedVisibility) {
      setColumnVisibility(JSON.parse(savedVisibility));
    }
  }, []);

  const fetchDriverRestStatus = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_API_URL}/api/driver-rest-status`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setDriverRestStatus(response.data.data || {});
    } catch (error) {
      console.error("Error fetching driver status:", error);
      setMessage(
        error.response?.data?.error || "Failed to fetch driver status"
      );
      setTimeout(() => setMessage(""), 3000);
    }
  };

  const handleRegisterRest = async () => {
    try {
      await axios.post(
        `${process.env.REACT_APP_BASE_API_URL}/api/register-rest`,
        {
          driver_name: selectedDriver,
          start_date: restForm.startDate,
          notes: null,
        },
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      );
      setShowRestModal(false);
      const statusResponse = await axios.get(
        `${process.env.REACT_APP_BASE_API_URL}/api/driver-rest-status`,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      );
      setDriverRestStatus(statusResponse.data.data || {});
    } catch (error) {
      console.error("Error registering rest:", error);
      setMessage(error.response?.data?.error || "Failed to register rest");
    }
  };

  const exportToExcel = () => {
    if (!gridRef.current || !gridRef.current.api) {
      alert("Grid is not ready yet!");
      return;
    }
    const visibleColumns = columns.filter(
      (col) =>
        !col.hide && col.headerName && !col.headerCheckboxSelection && col.field
    );
    const headers = visibleColumns.map((col) => col.headerName);
    const rowData = [];
    gridRef.current.api.forEachNodeAfterFilterAndSort((node) => {
      const row = {};
      visibleColumns.forEach((col, index) => {
        const field = col.field;
        // support lowercase and legacy uppercase fields
        let value =
          node.data[field] ?? node.data[field.toUpperCase()] ?? node.data[field.toLowerCase()] ?? "";
        const dateFields = [
          "journey_plane_date",
          "JOURNEY_PLANE_DATE",
          "ivms_check_date",
          "IVMS_CHECK_DATE",
          "next_arrival_date",
          "NEXT_ARRIVAL_DATE",
        ];
        if (dateFields.includes(field) && value) {
          const m = moment(value);
          value = m.isValid() ? m.local().format("DD MMM YYYY HH:mm") : value;
        }
        row[headers[index]] = value;
      });
      if (
        Object.values(row).some(
          (v) => v !== "" && v !== null && v !== undefined
        )
      ) {
        rowData.push(row);
      }
    });
    const worksheet = XLSX.utils.json_to_sheet(rowData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Journey Data");
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const data = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(data, `journey_data_${moment().format("YYYY-MM-DD_HH-mm")}.xlsx`);
  };

  // DFMS Report function
  const generateDfmsReport = () => {
    const dfmsData = {};
    filteredRecords.forEach((record) => {
      const vehicle = record.scheduled_vehicle || record.SCHEDULED_VEHICLE;
      if (!vehicle) return;
      if (!dfmsData[vehicle]) {
        dfmsData[vehicle] = {
          vehicle: vehicle,
          totalRecords: 0,
          dfmsNotWorking: 0,
          details: [],
        };
      }
      dfmsData[vehicle].totalRecords++;
      const dfmsValue = (record.dfms_check || record.DFMS_Check || "").toString();
      if (dfmsValue === "No") {
        dfmsData[vehicle].dfmsNotWorking++;
        dfmsData[vehicle].details.push({
          journeyPlanNo: record.journey_plane_no || record.JOURNEY_PLANE_NO,
          driverName: record.driver_name || record.DRIVER_NAME,
          date: record.journey_plane_date || record.JOURNEY_PLANE_DATE,
          ivmsPoint: record.ivms_point || record.IVMS_POINT,
          region: record.region || record.REGION,
        });
      }
    });
    const report = Object.values(dfmsData)

      .filter((item) => item.dfmsNotWorking > 0)
      .sort((a, b) => b.dfmsNotWorking - a.dfmsNotWorking);
    setDfmsReportData(report);
    setShowDfmsReport(true);
  };

  // Export DFMS Report to Excel
  const exportDfmsReportToExcel = () => {
    const exportData = dfmsReportData.map((item) => ({
      Vehicle: item.vehicle,
      "Total Records": item.totalRecords,
      "DFMS Not Working Count": item.dfmsNotWorking,
    }));
    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "DFMS Report");
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const data = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(data, `dfms_report_${moment().format("YYYY-MM-DD_HH-mm")}.xlsx`);
  };

  return (
    <>
      <header className="modify-records-header1">
        <TooltipMui title="Back to Main Page">
          <IconButton
            color="primary"
            onClick={handleMainPageClick}
            size="large"
            sx={{ mr: 1 }}
          >
            <ArrowBackIcon />
          </IconButton>
        </TooltipMui>
        <div
          className="export-controls"
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 8,
            marginRight: 10,
          }}
        >
          <TooltipMui title="Export to Excel">
            <IconButton color="primary" onClick={exportToExcel} size="large">
              <FileDownloadIcon />
            </IconButton>
          </TooltipMui>
          <TooltipMui title="DFMS Report">
            <IconButton
              color="secondary"
              onClick={generateDfmsReport}
              size="large"
            >
              <MulIcon />
            </IconButton>
          </TooltipMui>
        </div>

        <button
          onClick={() => {
            setDeleteMode(!deleteMode);
            setSelectedColumn("");
          }}
          className={`delete-mode-btn ${deleteMode ? "active" : ""}`}
        >
          {deleteMode ? "Cancel Delete Mode" : "Bulk Delete Mode"}
        </button>

        <div className="status-filter1">
          <label htmlFor="statusSelect">Filter By Status:</label>
          <select
            id="statusSelect"
            value={selectedStatus}
            onChange={(e) => handleStatusChange(e.target.value)}
          >
            <option value="IN TRANSIT">IN TRANSIT</option>
            <option value="CLOSED">CLOSED</option>
          </select>
        </div>

        {timerActive && (
          <div className="timer1">
            <span>Saving in {timer}s</span>
          </div>
        )}

        <div className="modify-records-footer">
          <div className="status-filter1">
            <label htmlFor="columnSelect">Select Column:</label>

            <select
              id="columnSelect"
              value={selectedColumn}
              onChange={handleColumnChange}
            >
              <option value="">--Select Column--</option>
              <option value="tracker">Tracker</option>
              <option value="sjm">SJM</option>
              <option value="carrier">Carrier</option>
              <option value="remarks">Remarks</option>
              <option value="next_point">Next Point</option>
              <option value="ivms_point">IVMS Point</option>
              <option value="offload_point">Offload Point</option>
              <option value="jp_status">JP Status</option>
              <option value="region">Region</option>
              <option value="driver_name">Driver Name</option>
              <option value="blue_key_name">Blue Key Name</option>
              <option value="planned_accommodation">
                Planned Accommodation
              </option>
              <option value="accommodation">Confirmed bookings</option>
              <option value="ivms_brand">IVMS Brand</option>
            </select>

            {selectedColumn === "tracker" && (
              <>
                <label htmlFor="trackerInput">Select or Enter Tracker:</label>
                <input
                  id="trackerInput"
                  list="trackerOptionsList"
                  className="newvaluebox"
                  value={newValue}
                  onChange={handleValueChange}
                  onInput={(e) =>
                    (e.target.value = e.target.value.toUpperCase())
                  }
                  disabled={deleteMode}
                />
                <datalist id="trackerOptionsList">
                  {trackerOptions.map((tracker) => (
                    <option key={tracker} value={tracker} />
                  ))}
                </datalist>
              </>
            )}


            {selectedColumn === "sjm" && (
              <>
                <label htmlFor="SJMInput">Select or Enter SJM:</label>
                <input
                  id="SJMInput"
                  list="SJMOptionsList"
                  className="newvaluebox"
                  value={newValue}
                  onChange={handleValueChange}
                  onInput={(e) =>
                    (e.target.value = e.target.value.toUpperCase())
                  }
                  disabled={deleteMode}
                />
                <datalist id="SJMOptionsList">
                  {sjmOptions.map((SJM) => (
                    <option key={SJM} value={SJM} />
                  ))}
                </datalist>
              </>
            )}


            {selectedColumn === "carrier" && (
              <>
                <label htmlFor="carrierInput">Select or Enter Carrier:</label>
                <input
                  id="carrierInput"
                  list="carrierOptionsList"
                  className="newvaluebox"
                  value={newValue}
                  onChange={handleValueChange}
                  onInput={(e) =>
                    (e.target.value = e.target.value.toUpperCase())
                  }
                  disabled={deleteMode}
                />
                <datalist id="carrierOptionsList">
                  {carrierOptions.map((carrier) => (
                    <option key={carrier} value={carrier} />
                  ))}
                </datalist>
              </>
            )}


            {selectedColumn === "remarks" && (
              <>
                <label htmlFor="remarksInput">Select or Enter Remarks:</label>
                <input
                  id="remarksInput"
                  list="remarksOptionsList"
                  className="newvaluebox"
                  value={newValue}
                  onChange={handleValueChange}
                  disabled={deleteMode}
                />
                <datalist id="remarksOptionsList">
                  {remarksoptions.map((remarks) => (
                    <option key={remarks} value={remarks} />
                  ))}
                </datalist>
              </>
            )}


            {selectedColumn === "next_point" && (
              <>
                <label htmlFor="nextPointInput">
                  Select or Enter Next Point:
                </label>
                <input
                  id="nextPointInput"
                  list="nextPointOptionsList"
                  className="newvaluebox"
                  value={newValue}
                  onChange={handleValueChange}
                  disabled={deleteMode}
                />
                <datalist id="nextPointOptionsList">
                  {nextPointOptions.map((nextPoint) => (
                    <option key={nextPoint} value={nextPoint} />
                  ))}
                </datalist>
              </>
            )}


            {selectedColumn === "ivms_point" && (
              <>
                <label htmlFor="ivmsPointInput">
                  Select or Enter IVMS Point:
                </label>
                <input
                  id="ivmsPointInput"
                  list="ivmsPointOptionsList"
                  className="newvaluebox"
                  value={newValue}
                  onChange={handleValueChange}
                  disabled={deleteMode}
                />
                <datalist id="ivmsPointOptionsList">
                  {ivmsPointOptions.map((ivmsPoint) => (
                    <option key={ivmsPoint} value={ivmsPoint} />
                  ))}
                </datalist>
              </>
            )}


            {selectedColumn === "ivms_brand" && (
              <>
                <label htmlFor="ivmsBrandInput">
                  Select or Enter IVMS Brand:
                </label>
                <input
                  id="ivmsBrandInput"
                  list="ivmsBrandOptionsList"
                  className="newvaluebox"
                  value={newValue}
                  onChange={handleValueChange}
                  disabled={deleteMode}
                />
                <datalist id="ivmsBrandOptionsList">
                  {ivmsBrandOptions.map((ivmsBrand) => (
                    <option key={ivmsBrand} value={ivmsBrand} />
                  ))}
                </datalist>
              </>
            )}


            {selectedColumn === "jp_status" && (
              <>
                <label htmlFor="jpStatusInput">
                  Select or Enter Journey Status:
                </label>
                <input
                  id="jpStatusInput"
                  list="jpStatusOptionsList"
                  className="newvaluebox"
                  value={newValue}
                  onChange={handleValueChange}
                  disabled={deleteMode}
                />
                <datalist id="jpStatusOptionsList">
                  <option value="IN TRANSIT" />
                  <option value="CLOSED" />
                </datalist>
              </>
            )}


            {selectedColumn === "region" && (
              <>
                <label htmlFor="regionInput">Select or Enter Region:</label>
                <input
                  id="regionInput"
                  list="regionOptionsList"
                  className="newvaluebox"
                  value={newValue}
                  onChange={handleValueChange}
                  disabled={deleteMode}
                />
                <datalist id="regionOptionsList">
                  {regionOptions.map((region) => (
                    <option key={region} value={region} />
                  ))}
                </datalist>
              </>
            )}


            {selectedColumn === "blue_key_name" && (
              <>
                <label htmlFor="blueKeyNameInput">
                  Select or Enter Blue Key Name:
                </label>
                <input
                  id="blueKeyNameInput"
                  list="blueKeyNameOptionsList"
                  className="newvaluebox"
                  value={newValue}
                  onChange={handleValueChange}
                  onInput={(e) =>
                    (e.target.value = e.target.value.toUpperCase())
                  }
                  disabled={deleteMode}
                />
                <datalist id="blueKeyNameOptionsList">
                  {bluekeyoptions.map((blue_key_name) => (
                    <option key={blue_key_name} value={blue_key_name} />
                  ))}
                </datalist>
              </>
            )}


            {selectedColumn === "planned_accommodation" && !deleteMode && (
              <>
                <label htmlFor="plannedAccommodationInput">
                  Select Planned Accommodation:
                </label>
                <input
                  id="plannedAccommodationInput"
                  list="plannedAccommodationOptionsList"
                  className="newvaluebox"
                  value={newValue}
                  onChange={handleValueChange}
                />
                <datalist id="plannedAccommodationOptionsList">
                  {plannedAccommodationOptions.map((option) => (
                    <option key={option} value={option} />
                  ))}
                </datalist>
              </>
            )}


            {selectedColumn === "accommodation" && !deleteMode && (
              <>
                <label htmlFor="confirmedBookingsInput">
                  Select Confirmed bookings:
                </label>
                <input
                  id="confirmedBookingsInput"
                  list="confirmedBookingsOptionsList"
                  className="newvaluebox"
                  value={newValue}
                  onChange={handleValueChange}
                />
                <datalist id="confirmedBookingsOptionsList">
                  {confirmedBookingsOptions.map((option) => (
                    <option key={option} value={option} />
                  ))}
                </datalist>
              </>
            )}


            {selectedColumn &&
              !deleteMode &&
              ![
                "tracker",
                "sjm",
                "carrier",
                "remarks",
                "next_point",
                "ivms_point",
                "ivms_brand",
                "jp_status",
                "region",
                "blue_key_name",
                "planned_accommodation",
                "accommodation",
              ].includes(selectedColumn) && (
                <>
                  <label htmlFor="newValue">New Value:</label>
                  <input
                    type="text"
                    id="newValue"
                    className="newvaluebox"
                    value={newValue}
                    onChange={handleValueChange}
                    placeholder="Enter new value"
                    disabled={deleteMode}
                  />
                </>
              )}

            {selectedColumn &&
              (deleteMode && selectedColumn === "accommodation" ? (
                <button
                  onClick={handleBulkDelete}
                  className="bulk-delete-btn"
                  disabled={selectedRowsCount === 0}
                >
                  Clear Accommodation ({selectedRowsCount})
                </button>
              ) : deleteMode && selectedColumn === "planned_accommodation" ? (
                <button
                  onClick={handleBulkDeletePlannedAccommodation}
                  className="bulk-delete-btn"
                  disabled={selectedRowsCount === 0}
                >
                  Clear Planned Accommodation ({selectedRowsCount})
                </button>
              ) : (
                <button
                  onClick={handleBulkUpdate}
                  className="bulk-update-btn"
                  disabled={
                    !newValue.trim() || selectedRowsCount === 0 || deleteMode
                  }
                >
                  Bulk Update ({selectedRowsCount})
                </button>
              ))}
          </div>

          <button onClick={handleBatchUpdate}>Save Changes</button>
          <button
            onClick={() => {
              resetFilters();
              clearFilterState();
            }}
            className="reset-btn"
          >
            Reset Filters
          </button>
        </div>
      </header>

      <div className="column-visibility-controls">
        <label htmlFor="columnVisibilitySelect">Column Visibility:</label>
        <Select
          id="columnVisibilitySelect"
          options={Object.keys(columnVisibility)
            .filter((column) => column !== "journey_plane_no")
            .map((column) => ({
              value: column,
              label: column.replace(/_/g, " "),
            }))}
          isMulti
          onChange={(selectedOptions) => {
            const selectedColumns = selectedOptions.map(
              (option) => option.value
            );
            const newVisibility = Object.keys(columnVisibility).reduce(
              (acc, column) => {
                acc[column] =
                  column === "journey_plane_no" ||
                  selectedColumns.includes(column);
                return acc;
              },
              {}
            );
            localStorage.setItem(
              "columnVisibilityState",
              JSON.stringify(newVisibility)
            );
            setColumnVisibility(newVisibility);
          }}
          value={Object.keys(columnVisibility)
            .filter(
              (column) =>
                column !== "journey_plane_no" && columnVisibility[column]
            )
            .map((column) => ({
              value: column,
              label: column.replace(/_/g, " "),
            }))}
        />
        <button
          onClick={() => {
            const newVisibility = Object.keys(columnVisibility).reduce(
              (acc, column) => {
                acc[column] = true;
                return acc;
              },
              {}
            );
            localStorage.setItem(
              "columnVisibilityState",
              JSON.stringify(newVisibility)
            );
            setColumnVisibility(newVisibility);
          }}
          className="show-all-btn"
          disabled={Object.values(columnVisibility).every((visible) => visible)}
        >
          Show All Columns
        </button>
      </div>

      {isLoading ? (
        <p>Loading records...</p>
      ) : (
        <div className="grid-container ag-theme-alpine">
          <AgGridReact
            ref={gridRef}
            onGridReady={onGridReady}
            rowSelection="multiple"
            columnDefs={columns}
            rowData={filteredRecords}
            getRowId={getRowId}
            rowHeight={40}
            suppressScrollOnNewData={true}
            enableCellTextSelection={true}
            defaultColDef={defaultColDef}
            enableClipboard={true}
            onCellValueChanged={handleChanges}
            onFilterChanged={handleGridFilterChange}
            animateRows={true}
            pagination={true}
            paginationPageSize={pageSize}
            rowBuffer={0}
            singleClickEdit={true}
            onSelectionChanged={onSelectionChanged}
            onCellContextMenu={handleCellContextMenu}
            getRowStyle={getRowStyle}
          />
        </div>
      )}

      <div className="footer">
        <span>Journey Count: {journeyCount}</span>
      </div>
      {message && <div className="modify-message">{message}</div>}

      {showRestModal && (
        <div
          className="modal"
          style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  Register Rest Period for {selectedDriver}
                </h5>
                <button
                  type="button"
                  className="close"
                  onClick={() => setShowRestModal(false)}
                >
                  <span>&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="form-group">
                  <label>Rest Start Date/Time:</label>
                  <input
                    type="datetime-local"
                    className="form-control"
                    value={restForm.startDate}
                    onChange={(e) =>
                      setRestForm({ ...restForm, startDate: e.target.value })
                    }
                  />
                </div>
                <div className="form-group">
                  <label>Duration (hours):</label>
                  <input
                    type="number"
                    className="form-control"
                    min="1"
                    max="48"
                    value={restForm.durationHours}
                    onChange={(e) =>
                      setRestForm({
                        ...restForm,
                        durationHours: parseInt(e.target.value),
                      })
                    }
                  />
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowRestModal(false)}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleRegisterRest}
                >
                  Register Rest Period
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* DFMS Report Modal */}
      {showDfmsReport && (
        <div
          className="modal"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0,0,0,0.5)",
            zIndex: 1300,
          }}
        >
          <div
            className="modal-dialog modal-lg"
            style={{
              margin: 0,
              maxWidth: 900,
              width: "90vw",
              maxHeight: "90vh",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <div
              className="modal-content"
              style={{
                maxHeight: "90vh",
                overflow: "hidden",
                display: "flex",
                flexDirection: "column",
              }}
            >
              {/* Modal Header with Close Icon at Right */}
              <div
                className="modal-header"
                style={{
                  flexShrink: 0,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <h5 className="modal-title" style={{ margin: 0 }}>
                  DFMS Not Working Report
                </h5>
                <IconButton
                  aria-label="close"
                  onClick={() => setShowDfmsReport(false)}
                  size="large"
                  style={{ marginLeft: 8 }}
                >
                  <CloseIcon />
                </IconButton>
              </div>
              <div
                className="modal-body"
                style={{ overflow: "auto", flex: 1, minHeight: 200 }}
              >
                <div
                  className="table-responsive"
                  style={{ maxHeight: "60vh", overflowY: "auto" }}
                >
                  <table
                    className="table table-sm table-bordered"
                    style={{ marginBottom: 0 }}
                  >
                    <thead>
                      <tr>
                        <th>Vehicle</th>
                        <th>Total Records</th>
                        <th>DFMS Not Working</th>
                        <th>Details</th>
                      </tr>
                    </thead>
                    <tbody>
                      {dfmsReportData.map((item, index) => (
                        <tr key={index}>
                          <td>{item.vehicle}</td>
                          <td>{item.totalRecords}</td>
                          <td className="text-danger font-weight-bold">
                            {item.dfmsNotWorking}
                          </td>
                          <td>
                            <TooltipMui title="Show Details">
                              <IconButton
                                size="small"
                                color="primary"
                                onClick={() => {
                                  setDfmsDetailsVehicle(item.vehicle);
                                  setDfmsDetailsRows(item.details);
                                  setDfmsDetailsOpen(true);
                                }}
                              >
                                <InfoOutlinedIcon />
                              </IconButton>
                            </TooltipMui>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  {dfmsReportData.length === 0 && (
                    <p className="text-center text-muted">
                      No DFMS issues found.
                    </p>
                  )}
                </div>
              </div>
              <div className="modal-footer" style={{ flexShrink: 0 }}>
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowDfmsReport(false)}
                >
                  Close
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={exportDfmsReportToExcel}
                  disabled={dfmsReportData.length === 0}
                >
                  Export Report
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modern DFMS Details Dialog */}
      <Dialog
        open={dfmsDetailsOpen}
        onClose={() => setDfmsDetailsOpen(false)}
        maxWidth="md"
        fullWidth
        PaperProps={{ style: { borderRadius: 12 } }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <span>
            DFMS Not Working Details - <b>{dfmsDetailsVehicle}</b>
          </span>
          <IconButton onClick={() => setDfmsDetailsOpen(false)} size="small">
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          {dfmsDetailsRows.length === 0 ? (
            <Typography color="text.secondary" align="center">
              No details available.
            </Typography>
          ) : (
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr style={{ background: "#f5f5f5" }}>
                  <th style={{ padding: 8, borderBottom: "1px solid #ddd" }}>
                    JP No
                  </th>
                  <th style={{ padding: 8, borderBottom: "1px solid #ddd" }}>
                    Driver
                  </th>
                  <th style={{ padding: 8, borderBottom: "1px solid #ddd" }}>
                    Date
                  </th>
                  <th style={{ padding: 8, borderBottom: "1px solid #ddd" }}>
                    IVMS Point
                  </th>
                  <th style={{ padding: 8, borderBottom: "1px solid #ddd" }}>
                    Region
                  </th>
                </tr>
              </thead>
              <tbody>
                {dfmsDetailsRows.map((row, idx) => (
                  <tr
                    key={idx}
                    style={{ background: idx % 2 ? "#fafbfc" : "#fff" }}
                  >
                    <td style={{ padding: 8, borderBottom: "1px solid #eee" }}>
                      {row.journeyPlanNo}
                    </td>
                    <td style={{ padding: 8, borderBottom: "1px solid #eee" }}>
                      {row.driverName}
                    </td>
                    <td style={{ padding: 8, borderBottom: "1px solid #eee" }}>
                      {row.date
                        ? moment(row.date).local().format("DD MMM YYYY HH:mm")
                        : ""}
                    </td>
                    <td style={{ padding: 8, borderBottom: "1px solid #eee" }}>
                      {row.ivmsPoint}
                    </td>
                    <td style={{ padding: 8, borderBottom: "1px solid #eee" }}>
                      {row.region}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setDfmsDetailsOpen(false)}
            color="primary"
            variant="outlined"
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
export default ModifyRecords;
